import endpoints from '../../../../api/endpoints';
import { authentication } from '../../../authentication';
import { API_VERSION } from '../../../../api/constans';
import { AUTHORIZATION_TOKEN, CORRELATION_ID } from '../../../../constants/storage';

export type ReportType =
  | 'airtimeAndData'
  | 'ussd'
  | 'wap'
  | 'voice'
  | 'sms'
  | 'operatorLookup'
  | 'transfer'
  | 'payout'
  | 'customerValidation'
  | 'merchantPayment'
  | 'customerAuthentication'
  | 'customerEnrollment';

export const openGlobalToast = (message: string, severity: 'success' | 'info' | 'warning' | 'error' = 'info', progress?: number) => {
  window.dispatchEvent(
    new CustomEvent('global-toast', {
      detail: { message, severity, autoHideDuration: 6000, ...(progress !== undefined && { progress }) }
    })
  );
};

const updateGlobalToastProgress = (progress: number) => {
  window.dispatchEvent(
    new CustomEvent('global-toast-progress', {
      detail: { progress }
    })
  );
};

export const downloadReport = async (id: string, name: string, type: ReportType, size?: number) => {
  const url = endpoints.reportDownload(id, type);
  try {
    openGlobalToast('Downloading report…', 'info');
    updateGlobalToastProgress(0);

    await authentication.updateToken();

    const blob = await new Promise<Blob>((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url.toString(), true);
      xhr.responseType = 'blob';

      const token = localStorage.getItem(AUTHORIZATION_TOKEN);
      const correlationId = localStorage.getItem(CORRELATION_ID);
      
      if (token) {
        xhr.setRequestHeader('Authorization', `Bearer ${token}`);
        xhr.setRequestHeader('X-Frontend-API-version', API_VERSION);
      }
      
      if (correlationId) {
        xhr.setRequestHeader('X-Request-Correlation-Id-V2', correlationId);
      }

      let isFinalizing = false;

      xhr.onprogress = (event: ProgressEvent) => {
        let percent = 0;
        if (event.lengthComputable) {
          percent = (event.loaded / event.total) * 100;
        } else if (size && size > 0) {
          percent = (event.loaded / size) * 100;
        }
        
        if (percent >= 100) {
          if (!isFinalizing) {
            isFinalizing = true;
            openGlobalToast('Finalizing...', 'info', 100);
          }
        } else if (percent > 0) {
          updateGlobalToastProgress(percent);
        }
      };

      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(xhr.response as Blob);
        } else {
          reject(new Error('Failed to download report'));
        }
      };

      xhr.onerror = () => reject(new Error('Network error during download'));
      xhr.send();
    });

    const objectUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = objectUrl;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.setTimeout(() => window.URL.revokeObjectURL(objectUrl), 1000);

    openGlobalToast('Report downloaded successfully.', 'success');
  } catch (error) {
    console.error('Download report error:', error);
    openGlobalToast('Failed to download the report.', 'error');
  }
};

